import React from "react";
import { Form, Button, Switch, message,Tooltip } from 'antd';
import { hasAuth } from "../../../../utils/NHCore";
import NHFetch from "../../../../utils/NHFetch";
import { NHConfirm } from "../../../common/NHModal/index";
import NHTable from "../../../common/NHTable/index";
import NHModal from "../../../common/NHModal/index";
import EditFlModal from "./EditFlModal";
import getSize from "../../../../utils/getSize";

const baseUrlPath = "/xxfbFl"; //信息发布管理模块路径

/**
 * 信息发布编辑表单
 */
class EditFlForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdd: true,
            flData: {},
        }
    }

    //渲染前加载启用停用按钮参数
    componentDidMount() {
        NHFetch("/proData/selectDataList", "GET", { sign: 'dmk_xtgl_zt' })
            .then(resData => {
                if (resData.data != null) {
                    if (resData.data[0] != null && resData.data[1] != null && resData.data[0].VALUE == '1' && resData.data[1].VALUE == '0') {
                        this.setState({ zt0: resData.data[1].LABEL, zt1: resData.data[0].LABEL });
                    }
                }
            })
    }

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setState({ flData: {}, isAdd: true });
        this.refs.nhModal.show();
    }

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        this.setState({ flData: record, isAdd: false });
        this.refs.nhModal.show();
    }

    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({ formInitData: record });
        this.setCurrentPageShow('showFlag');
    }
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let flbz = record.FLBZ;
            this.handleDelete([flbz]);
        }, "warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (flbzs) => {
        NHFetch(baseUrlPath + '/deleteByMulti', 'POST', flbzs)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showDeleteBtn: true, showSendBtn: true
            })
        } else {
            this.setState({
                showDeleteBtn: false, showSendBtn: false
            })
        }
    }

    //保存分类
    handleModalOk = () => {
        this.nhForm.validateFields((err, formData) => {
            if (err) {
                this.refs.nhModal.stopLoading();
                return;
            }
            if (formData) {
                let url = '';
                let data = formData;
                if (this.state.isAdd) {
                    url = baseUrlPath + "/insert";
                } else {
                    url = baseUrlPath + "/update";
                }
                NHFetch(url, 'POST', data)
                    .then(res => {
                        if (res.code == 200) {
                            this.refs.nhModal.close();
                            message.success("修改信息发布成功！");
                            this.refs.nhTable.filterTableData();
                        } else {
                            message.warn("修改异常!");
                        }
                    }).catch(err => {
                        this.refs.nhModal.stopLoading();
                    })
            }
        });
    }

    //单行启用禁用
    updateState = (record) => {
        let FLBZ = record.FLBZ;
        NHFetch(baseUrlPath + "/updateState", "POST", { "flbz": FLBZ })
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                } else {
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    }

    render() {
        //列参数flbz,flbt,sfnrwy,zt,fflbz,pxh
        const columns = [
            {
                title: '序号',
                width: '70',
                dataIndex: 'ROW_ID'
            }, {
                title: '分类标题',
                width: '200',
                dataIndex: 'FLBT',
                render:(text,record,index)=>{
                    return (text && text.length>10)?<Tooltip title={text}>{text.substring(0,10)+"..."}</Tooltip>:text;
                },
                searchType:"input"
            }, {
                title: '分类标志',
                width: '200',
                dataIndex: 'FLBZ',
                render:(text,record,index)=>{
                    return (text && text.length>10)?<Tooltip title={text}>{text.substring(0,10)+"..."}</Tooltip>:text;
                },
                searchType:"input"
            }, {
                title: '所属分类',
                width: '200',
                dataIndex: 'FFLBT',
                searchType:"input"
            }, {
                title: '内容是否唯一',
                width: '150',
                dataIndex: 'SFNRWYMC',
                searchType:"input"
            }, {
                title: '排序号',
                width: '100',
                dataIndex: 'PXH',
                searchType:"input"
            }, {
                title: '状态',
                width: '100',
                dataIndex: 'ZTMC',
                render: (text, record, index) => {
                    const status = record.ZT == '1' ? true : false;
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_xxfb:fl_updateState') ?
                            <Switch checkedChildren={this.state.zt1} unCheckedChildren={this.state.zt0} checked={status} onChange={() => this.updateState(record)} /> :
                            <span>{status ? this.state.zt1 : this.state.zt0}</span>
                    );
                },
                searchType:"select"
            }
        ];
        //行内操作
        const action = [
            { title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_fwwgl_xxfb:fl_udpate' },
            { title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_fwwgl_xxfb:fl_multiple_delete' },
        ];
        const { zt0, zt1 } = this.props;
        return (
            <div style={{ height: getSize().windowH - 261 }}>
                <NHTable ref='nhTable'
                    rowKey={record => record.FLBZ}
                    height={350}
                    autoHeightFlag={true}
                    sign={"zhxg_yxxt_fwwgl_xxfbfl_queryPage"}
                    columns={columns}
                    action={action}
                    tip="新增：最多只能建二级分类，删除：如果有下级分类，则要先删除子类后才能删除父分类"
                    rowSelectionChange={this.rowSelectionChange}
                >
                    {hasAuth('zhxg_yxgl_fwwgl_xxfb:fl_add') ? <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button> : null}
                    {hasAuth('zhxg_yxgl_fwwgl_xxfbfl:fl_delete') ? <Button type="danger" ghost style={{ marginLeft: 10, display: this.state.showDeleteBtn ? undefined : 'none' }}
                        onClick={this.handleMultiDeleteBtnClick}>删除</Button> : null}
                </NHTable>
                <NHModal ref="nhModal" width={720} title={this.state.isAdd ? '新增分类' : '修改分类'} onOk={this.handleModalOk}>
                    <EditFlModal ref={(form) => this.nhForm = form} flData={this.state.flData} zt0={this.state.zt0} zt1={this.state.zt1} />
                </NHModal>
            </div>
        );
    }
}

const edit = Form.create()(EditFlForm);

export default edit;


// WEBPACK FOOTER //
// ./components/fwwgl/xxfb/xxfbfl/EditFlForm.js